<template>
  <div class="document-driven-not-found not-prose">
    <main>
      <p>
        404
      </p>
      <div class="content">
        <div class="text-section">
          <h1>
            Not Found
          </h1>
          <p>
            This is not the page you're looking for.
          </p>
        </div>

        <div class="button-section">
          <ButtonLink
            href="/"
            size="large"
            variant="primary"
          >
            Go back home
          </ButtonLink>
        </div>
      </div>
    </main>
  </div>
</template>

<style scoped>
.document-driven-not-found {
  display: flex;
  flex: 1;
  padding: 1rem 1rem 4rem 1rem;
}

@media (min-width: 640px) {
  .document-driven-not-found {
    padding: 1.5rem 1.5rem 6rem 1.5rem;
  }
}

@media (min-width: 768px) {
  .document-driven-not-found {
    display: grid;
    place-items: center;
  }
}

@media (min-width: 1024px) {
  .document-driven-not-found {
    padding-left: 2rem;
    padding-right: 2rem;
  }
}

.document-driven-not-found main {
  margin-left: auto;
  margin-right: auto;
  max-width: 100%;
}

@media (min-width: 640px) {
  .document-driven-not-found main {
    display: flex;
    gap: 1.5rem;
  }
}

/* 404 number */
.document-driven-not-found main > p {
  font-size: 2.25rem;
  font-weight: 700;
  line-height: 1.25;
  color: rgb(59 130 246);
}

@media (min-width: 640px) {
  .document-driven-not-found main > p {
    font-size: 3rem;
  }
}

.text-section {
  border: none;
}

@media (min-width: 640px) {
  .text-section {
    border-left: 1px solid rgb(229 231 235);
    padding-left: 1.5rem;
  }
}

@media (prefers-color-scheme: dark) {
  .text-section {
    border-left-color: rgb(31 41 55);
  }
}

.text-section h1 {
  font-size: 2.25rem;
  font-weight: 800;
  letter-spacing: -0.025em;
  color: rgb(17 24 39);
}

@media (min-width: 640px) {
  .text-section h1 {
    font-size: 3rem;
  }
}

@media (prefers-color-scheme: dark) {
  .text-section h1 {
    color: rgb(229 231 235);
  }
}

.text-section p {
  margin-top: 0.25rem;
  font-size: 1.25rem;
  color: rgb(55 65 81);
}

@media (prefers-color-scheme: dark) {
  .text-section p {
    color: rgb(156 163 175);
  }
}

.button-section {
  margin-top: 2.5rem;
  flex: none;
  gap: 0.75rem;
}
</style>
